import { useQuery } from "@tanstack/react-query";
import { shippingCostApi } from "../services/shippingCost.api";
import { TShippingCostFilter } from "../../../interfaces/shippingCostType";
import { IApiPagination } from "../../../interfaces/IPagination";

export type UseShippingCostsFilterQueryParams = {
  filter: TShippingCostFilter;
  pagination: IApiPagination;
};

export const useShippingCostsFilterQuery = (
  params: UseShippingCostsFilterQueryParams,
) => {
  return useQuery({
    queryKey: ["shipping-costs-filter", params],
    queryFn: async () => {
      const res = await shippingCostApi.getShippingCosts(
        params.filter,
        params.pagination,
      );
      return res.data;
    },
    staleTime: 1000 * 60, // 1 minute
  });
};

export const useShippingCostByIdQuery = (shippingCostId?: string) => {
  return useQuery({
    queryKey: ["shipping-cost-by-id", shippingCostId],
    queryFn: () => shippingCostApi.getShippingCostById(shippingCostId as string),
    staleTime: 1000 * 60, // 1 minute
    enabled: !!shippingCostId,
  });
};
